import EditFormGroup from "components/form/EditFormGroup";
import React, { forwardRef } from "react";
import { roleOption, statusOption } from "../StaffComponent";

export default forwardRef(function CustomerForm(
  {
    data = {},
    onChange = () => {},
    onError = () => {},
    // define onchange parameter 'state', 'event', 'name-value'
    type = "state",
    actionType = "add",
  },
  ref
) {
  return (
    <div>
      <EditFormGroup
        ref={ref}
        data={data}
        onChange={onChange}
        onError={onError}
        type={type}
        layout={[
          {
            name: "name",
            label: "Full Name",
            type: "text",
            size: "small",
            required: true,
          },
          {
            name: "phone",
            label: "Phone",
            required: true,
            size: "small",
            type: "phone",
          },
          {
            name: "email",
            label: "Email",
            type: "email",
            readOnly: actionType === "add" ? false : true,
            required: true,
            size: "small",
          },
          ...(actionType === "add"
            ? [
                {
                  name: "password",
                  label: "Password",
                  type: "password",
                  size: "small",
                },
                {
                  name: "confirm_password",
                  label: "Confirm Password",
                  type: "password",
                  size: "small",
                },
              ]
            : []),

          {
            name: "role",
            label: "Role",
            type: "native_select",
            options: roleOption,
            // optionLabel: (option) => option.label,
            size: "small",
            required: true,
          },
          {
            name: "status",
            label: "Status",
            type: "native_select",
            options: statusOption,
            // optionLabel: (option) => option.label,
            size: "small",
          },
        ]}
        isLabel
        fullWidth={true}
        direction="column"
        spacing={2}
      />
    </div>
  );
});
